export enum OnboardingStepType {
  GOALS = "goals",
  INSPIRATION = "inspiration",
  PLANTS = "plants",
  WISHLIST = "wishlist",
  PHOTOS = "photos",
  REVIEW = "review",
  EXTERIOR = "exterior",
}
